import React, { useEffect, useState } from "react";
import { useTable, useSortBy } from "react-table";
import Skeleton from "@mui/material/Skeleton";
import { useTranslation } from "react-i18next";
import { detectWebDeviceType } from "../../utils";

function Table({
  columns,
  data,
  pagination, // { current, pageSize, onChange }
  setPagination,
  onRowClick,
  selectedRowIndex,
  isLoadingData,
}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const deviceType = detectWebDeviceType();


  console.log("PAGINATION", pagination);
  console.log("DATA ------>", data);

  

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
  } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  // Manage loading display
  useEffect(() => {
    if (data.length > 0) {
      setIsLoading(false);
    } else if (isLoadingData) {
      setIsLoading(true);
    }
  }, [data, isLoadingData]);

  if (isLoading) {
    return (
      <div className="p-4">
        {[...Array(6)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height={index % 2 === 0 ? 40 : 60}
            className="mb-3"
          />
        ))}
      </div>
    );
  }

  return (
    <>
      {data.length > 0 && (
        <table {...getTableProps()} className="w-full">
          <thead className="bg-[#C9ECF7] text-zinc-800 font-semibold text-lg text-left capitalize whitespace-nowrap">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={column.id}
                    className="px-6 py-3 text-center"
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  key={row.id}
                  onClick={() => onRowClick(row.original)}
                  className={`cursor-pointer ${selectedRowIndex === i ? "bg-gray-200" : ""
                    } border-b border-gray-300`}
                >
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps()}
                      key={cell.column.id}
                      className={`px-6 ${deviceType === "tablet" ? "py-2" : "py-3"} text-center`}
                    >
                      <div className={`${deviceType === "tablet" ? "text-base" : "text-lg"} text-gray-900`}>
                        {cell.render("Cell")}
                      </div>
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

       <footer className="flex justify-center text-lg self-center px-5 mt-2  w-full">
        <div className="flex gap-5 text-center text-black font-semibold w-2/12">
           <button
            onClick={() => setPagination((prevValue) => prevValue - 20)}
            // disabled={pagination <= 0}
            disabled={pagination <= 0 || isLoadingData}
            className="p-2 rounded-full bg-gray-200"
            style={{ width: "40px", height: "40px" }}
          >
            &lt;
          </button>
          <div className="flex-auto my-auto">
            {t("Results")}{" "}
            <strong>
              {pagination + 1}-{pagination + data.length}
            </strong>
          </div>
          <button
            onClick={() => setPagination((prevValue) => prevValue + 20)}
            // disabled={data?.length < 10}
            disabled={data?.length < 10 || isLoadingData}
            className="p-2 rounded-full bg-gray-200"
            style={{ width: "40px", height: "40px" }}
          >
            &gt;
          </button>
        </div>
      </footer>

      {/* Pagination Footer */}
      {/* <footer className="flex justify-center items-center text-lg font-semibold mt-4">
        <div className="flex gap-5 items-center">
          <button
            onClick={() => pagination.onChange(Math.max(1, pagination.current - 1))}
            disabled={pagination.current === 1 || isLoadingData}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition"
            style={{ width: "40px", height: "40px" }}
          >
            &lt;
          </button>

          <span>
            {t("Results")}{" "}
            <strong>
              {(pagination - 1) * pagination.pageSize + 1} –{" "}
              {(pagination- 1) * pagination.pageSize + data.length}
            </strong>
          </span>

          <button
            onClick={() => pagination.onChange(pagination.current + 1)}
            disabled={data.length < pagination.pageSize || isLoadingData}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition"
            style={{ width: "40px", height: "40px" }}
          >
            &gt;
          </button>
        </div>
      </footer> */}
    </>
  );
}

export default Table;



// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { useSortBy, useTable, usePagination } from "react-table";
// import Skeleton from "@mui/material/Skeleton";
// import { useSelector, useDispatch } from "react-redux";
// import { useTranslation } from "react-i18next";
// import { detectWebDeviceType } from "../../utils";

// function Table({
//   columns,
//   onRowClick,
//   data,
//   pagination,
//   setPagination,
//   selectedRowIndex,
//   isLoadingData,
// }) {
//   const { t, i18n } = useTranslation();
//   const [isLoading, setIsLoading] = useState(true);
//   const { orders } = useSelector((state) => state.orders);
//   // const data = useMemo(() => orders || [], [orders]);

//   // console.log("TABLE DATA", data);

//   const deviceType = detectWebDeviceType();
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     prepareRow,
//     page,
//     canPreviousPage,
//     canNextPage,
//     pageOptions,
//     pageCount,
//     gotoPage,
//     nextPage,
//     previousPage,
//     setPageSize,
//     state: { pageIndex, pageSize },
//     useSortBy,
//   } = useTable(
//     {
//       columns,
//       data,
//       initialState: { pageIndex: 0, pageSize: 20 },
//     },
//     usePagination
//   );

//   // useEffect(() => {
//   //   if (data.length > 0) {
//   //     setIsLoading(false);
//   //   }
//   // }, [data]);

//   useEffect(() => {
//     if (data.length > 0) {
//       setIsLoading(false);
//     } else if (isLoadingData) {
//       setIsLoading(true);
//     }
//   }, [data, isLoadingData]);

//   if (isLoading) {
//     return (
//       <div className="">
//         <Skeleton
//           variant="rectangular"
//           width={"100%"}
//           height={"10px"}
//           className="mb-3 mt-2"
//         />
//         <Skeleton
//           variant="rectangular"
//           width={"80%"}
//           height={"40px"}
//           className="mb-3"
//         />
//         <Skeleton
//           variant="rectangular"
//           width={"70%"}
//           height={"80px"}
//           className="mb-3"
//         />
//         <Skeleton
//           variant="rectangular"
//           width={"90%"}
//           height={"20px"}
//           className="mb-3"
//         />
//         <Skeleton
//           variant="rectangular"
//           width={"50%"}
//           height={"40px"}
//           className="mb-3"
//         />
//         <Skeleton
//           variant="rectangular"
//           width={"70%"}
//           height={"80px"}
//           className="mb-3"
//         />
//         <Skeleton
//           variant="rectangular"
//           width={"90%"}
//           height={"20px"}
//           className="mb-3"
//         />
//         <Skeleton
//           variant="rectangular"
//           width={"100%"}
//           height={"50px"}
//           className="mb-3"
//         />
//       </div>
//     );
//   }

//   return (
//     <>
//     {data.length > 0 && 
//       <table {...getTableProps()} className="w-full">
//         <thead className="px-10 py-4 w-full font-semibold text-lg tracking-wide text-left capitalize whitespace-nowrap bg-[#C9ECF7] text-zinc-800 max-md:px-5 max-md:max-w-full">
//           <tr>
//             {headerGroups.map((headerGroup) =>
//               headerGroup.headers.map((column) => (
//                 <th
//                   {...column.getHeaderProps()}
//                   className="px-6 py-[2px] text-center"
//                 >
//                   {column.render("Header")}
//                 </th>
//               ))
//             )}
//           </tr>
//         </thead>
//         <tbody {...getTableBodyProps()}>
//           {page.map((row, i) => {
//             prepareRow(row);
//             return (
//               <tr
//                 {...row.getRowProps()}
//                 className={`gap-5 self-center mt-6 w-full tracking-wide capitalize max-w-[983px] text-zinc-800 max-md:flex-wrap max-md:max-w-full cursor-pointer ${
//                   selectedRowIndex === i ? "bg-gray-200" : ""
//                 }`}
//                 style={{ borderBottom: "1px solid #ccc" }}
//                 onClick={() => onRowClick(row.original)}
//               >
//                 {row.cells.map((cell) => (
//                   <td
//                     {...cell.getCellProps()}
//                     className={`px-6 ${
//                       deviceType == "tablet" ? "py-2" : "py-3"
//                     } whitespace-nowrap text-center`}
//                   >
//                     <div
//                       className={`${
//                         deviceType == "tablet" ? "text-base" : "text-lg"
//                       } text-gray-900`}
//                     >
//                       {cell.render("Cell")}
//                     </div>
//                   </td>
//                 ))}
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>}
    

//       <footer className="flex justify-center text-lg self-center px-5 mt-2  w-full">
//         <div className="flex gap-5 text-center text-black font-semibold w-2/12">
//           <button
//             onClick={() => setPagination((prevValue) => prevValue - 20)}
//             // disabled={pagination <= 0}
//             disabled={pagination <= 0 || isLoadingData}
//             className="p-2 rounded-full bg-gray-200"
//             style={{ width: "40px", height: "40px" }}
//           >
//             &lt;
//           </button>
//           <div className="flex-auto my-auto">
//             {t("Results")}{" "}
//             <strong>
//               {pagination + 1}-{pagination + data.length}
//             </strong>
//           </div>
//           <button
//             onClick={() => setPagination((prevValue) => prevValue + 20)}
//             // disabled={data?.length < 10}
//             disabled={data?.length < 10 || isLoadingData}
//             className="p-2 rounded-full bg-gray-200"
//             style={{ width: "40px", height: "40px" }}
//           >
//             &gt;
//           </button>
//         </div>
//       </footer>
//     </>
//   );
// }

// export default Table;
